<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />

        <action-button type="save" @click="save" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="moduleoptioncoursetype.name"
                  v-model="moduleoptioncoursetype.name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('moduleoptioncoursetypes.name')"
                  :error-messages="errors.collect('moduleoptioncoursetype.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="moduleoptioncoursetype.price"
                  v-model="computedPrice"
                  @keypress="$keyDown_PriceOnly($event)"
                  :hint="'Format:' + PRICE_FORMAT"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('moduleoptioncoursetypes.price')"
                  :error-messages="errors.collect('moduleoptioncoursetype.price')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <!--<v-flex lg3 md4 sm6 xs12>
                                <v-autocomplete
                                    name="moduleoptioncoursetype.coursetype_id"
                                    v-model="moduleoptioncoursetype.coursetype_id"
                                    class="required-field" v-validate="'required'"
                                    :items="allcoursetypes"
                                    item-text="fullname"
                                    item-value="id"
                                    :label="$t('coursetypes.title')"
                                    autocomplete="new-password"
                                    :error-messages="errors.collect('moduleoptioncoursetype.coursetype_id')"
                                    clearable
                                ></v-autocomplete>
                            </v-flex>-->
              <v-flex xs12>
                <v-textarea
                  name="moduleoptioncoursetype.comment"
                  v-model="moduleoptioncoursetype.comment"
                  rows="1"
                  auto-grow
                  :label="$t('moduleoptioncoursetypes.comment')"
                  :error-messages="errors.collect('moduleoptioncoursetype.comment')"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "ModuleOptionCourseTypeForm",

  props: ["id", "modal", "moduleoption_id", "coursetemplate_id", "coursetypes", "coursetypegroup_id", "from_module"],

  data() {
    return {
      api_module: "moduleoptioncoursetype",
      page_title: "",
      predata: {},
      moduleoptioncoursetype: {},
      allcoursetypes: [],
      dictionary: {
        attributes: {
          "moduleoptioncoursetype.moduleoption_id": this.$t("moduleoptioncoursetypes.moduleoption_id"),
          "moduleoptioncoursetype.coursetype_id": this.$t("moduleoptioncoursetypes.coursetype_id"),
          "moduleoptioncoursetype.name": this.$t("moduleoptioncoursetypes.name"),
          "moduleoptioncoursetype.price": this.$t("moduleoptioncoursetypes.price"),
          "moduleoptioncoursetype.comment": this.$t("moduleoptioncoursetypes.comment")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.moduleoptioncoursetype, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedPrice: {
      get() {
        return this.$priceFormatGetter(this.moduleoptioncoursetype.price)
      },
      set(val) {
        this.$set(this.moduleoptioncoursetype, "price", this.$priceFormatSetter(val))
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (this.from_module == "course") {
      this.api_module = "coursemoduleoptioncoursetype"
    }

    let lists = [{ key: "coursetypes", module: "coursetypes", query: "show_all=true&query_coursetypegroup_id=" + this.coursetypegroup_id }]

    axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
      this.allcoursetypes = res.data.coursetypes

      if (!this.id) {
        this.page_title = this.$t("moduleoptioncoursetypes.new_moduleoptioncoursetype")
        this.moduleoptioncoursetype = {
          moduleoption_id: this.moduleoption_id,
          coursetemplate_id: this.coursetemplate_id
        }

        // JSON stringify and parse to remove variable reactiveness
        this.predata = JSON.parse(JSON.stringify(this.moduleoptioncoursetype))
      } else {
        axios
          .get(this.API_URL + this.api_module + "/" + this.id)
          .then((res) => {
            this.moduleoptioncoursetype = res.data.data
            this.page_title = this.$t("moduleoptioncoursetypes.edit_moduleoptioncoursetype", {
              name: this.moduleoptioncoursetype.name
            })

            // JSON stringify and parse to remove variable reactiveness
            this.predata = JSON.parse(JSON.stringify(this.moduleoptioncoursetype))
          })
          .catch((err) => console.log(err))
      }
    })
  },

  methods: {
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!this.moduleoptioncoursetype.id) {
              // Create
              axios
                .post(this.API_URL + this.api_module, {
                  name: this.moduleoptioncoursetype.name,
                  price: this.moduleoptioncoursetype.price,
                  comment: this.moduleoptioncoursetype.comment,
                  moduleoption_id: this.moduleoption_id,
                  coursetemplate_id: this.coursetemplate_id,
                  coursetype_id: this.moduleoptioncoursetype.coursetype_id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.moduleoptioncoursetype = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.moduleoptioncoursetype))

                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "moduleoptioncoursetype",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.$router
                          .replace(this.BACKEND_URL + `/moduleoptioncoursetypes/edit/${vm.moduleoptioncoursetype.id}`)
                          .catch(() => {})
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + this.api_module, {
                  id: this.moduleoptioncoursetype.id,
                  name: this.moduleoptioncoursetype.name,
                  price: this.moduleoptioncoursetype.price,
                  comment: this.moduleoptioncoursetype.comment,
                  moduleoption_id: this.moduleoption_id,
                  coursetemplate_id: this.coursetemplate_id,
                  coursetype_id: this.moduleoptioncoursetype.coursetype_id
                })
                .then((res) => {
                  vm.moduleoptioncoursetype = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.moduleoptioncoursetype))

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "moduleoptioncoursetype",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped></style>
